import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";


interface CelebrationPageProps {
  returnUrl?: string;
  logoUrl?: string;
}

const CelebrationPage: React.FC<CelebrationPageProps> = ({
  returnUrl = "/dashboard",
}) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const staffName = params.get("staffName");
  const hotelName = params.get("hotelName");
  
const navigate = useNavigate();

useEffect(() => {
  if (!staffName || !hotelName) {
    navigate("/404");
  }
}, [staffName, hotelName, navigate]);

  useEffect(() => {
    const confettiContainer = document.getElementById("confetti");
    if (confettiContainer) {
      const colors = ["#ffffff", "#0d47a1"];

      for (let i = 0; i < 80; i++) {
        const confetti = document.createElement("div");
        confetti.className = "confetti-piece";
        confetti.style.left = `${Math.random() * window.innerWidth}px`;
        confetti.style.width = confetti.style.height = `${6 + Math.random() * 6}px`;
        confetti.style.backgroundColor =
          colors[Math.floor(Math.random() * colors.length)];
        confetti.style.animationDuration = `${3 + Math.random() * 3}s`;
        confetti.style.animationDelay = `${Math.random() * 2}s`;

        confettiContainer.appendChild(confetti);
      }
    }

    const audio = new Audio("https://www.soundjay.com/human/applause-8.mp3");
    audio.volume = 0.35;
    audio.play().catch(() => {});
  }, []);

  return (
    <div className="celebration-container">
      <div id="confetti"></div>

      <div className="celebration-content">
        <h1 className="headline">🎉 You're Amazing, {staffName}! 🎉</h1>

        <p className="message">
          We celebrate your dedication and contribution to {hotelName}.
          Your work makes a difference every single day, and today we
          celebrate you.
        </p>

        <a href={returnUrl} className="button">
          Return to Dashboard
        </a>
      </div>

      {/* Single clap at bottom */}
      <div className="clap">👏</div>

      <style>{`

      .celebration-container {
        font-family: 'Helvetica Neue', Arial, sans-serif;
        background: radial-gradient(circle at top left, #0d47a1, #1976d2);
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        text-align: center;
        position: relative;
        overflow: hidden;
        padding: 40px 24px;
        box-sizing: border-box;
      }

      .celebration-content {
        max-width: 600px;
        z-index: 3;
        animation: fadeIn 1s ease;
      }

      .headline {
        font-size: 42px;
        margin-bottom: 20px;
        animation: headlineMove 3s ease-in-out infinite alternate;
      }

      .message {
        font-size: 19px;
        line-height: 1.7;
        margin-bottom: 30px;
      }

      .button {
        display: inline-block;
        padding: 14px 30px;
        background: white;
        color: #0d47a1;
        font-weight: bold;
        border-radius: 6px;
        text-decoration: none;
        transition: transform .2s ease, box-shadow .2s ease;
      }

      .button:hover {
        transform: translateY(-3px);
        box-shadow: 0 10px 25px rgba(0,0,0,0.2);
      }

      /* Confetti */

      .confetti-piece {
        position: absolute;
        opacity: 0.85;
        animation: confettiFall linear infinite;
      }

      @keyframes confettiFall {
        0% {
          transform: translateY(-20px) translateX(0) rotate(0deg);
        }
        50% {
          transform: translateY(50vh) translateX(20px) rotate(180deg);
        }
        100% {
          transform: translateY(100vh) translateX(-20px) rotate(360deg);
        }
      }

      /* Single clap bottom center */

      .clap {
        position: absolute;
        bottom: 25px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 60px;
        animation: clapPulse 1.2s infinite ease-in-out;
      }

      @keyframes clapPulse {
        0% { transform: translateX(-50%) scale(1); }
        50% { transform: translateX(-50%) scale(1.2); }
        100% { transform: translateX(-50%) scale(1); }
      }

      /* Headline animation */

      @keyframes headlineMove {
        0% { transform: translateY(0); }
        100% { transform: translateY(-6px); }
      }

      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
      }

      /* Mobile adjustments */

      @media (max-width: 600px) {

        .headline {
          font-size: 30px;
        }

        .message {
          font-size: 17px;
        }

        .celebration-container {
          padding: 50px 20px;
        }

      }

      `}</style>
    </div>
  );
};

export default CelebrationPage;